import React, { useEffect, useState } from 'react';
import { Building } from '../../../confi-state';
import { Segment } from '../models/segment';
import { ColumnService } from './column-service';
import { columnDefs, columnSubtype, subtypeEnum, variantEnum } from './models/column-definition';
import { columnType } from './models/column-type.enum';
import { headType } from './models/head-type.enum';
import { CorridorColumn, PropsCorridor } from './models/props-config';
import { segmentType } from './models/segment-type';
import { partTypeEnum } from './models/part-type.enum';
import Refine from '../Refine/Refine';
import { RefineService } from '../Refine/refine.service';
import { ServiceManager } from '../../../services/service-manager';
import { buildingType } from '../models/building-type.enum';
import { defaultHead } from './models/head-types.model';
import CorridorPartSelector from './CorridorPartSelector/CorridorPartSelector';
import { SectionJSON } from '../../../models/section-json';
import { CorridorService } from './corridor.service';
import CorridorSegmentSelector from './CorridorSegmentSelector/CorridorSegmentSelector';

const buildingChange = (buildingProps: PropsCorridor, currentBuilding: Building, onChangeBuilding) => {
    onChangeBuilding(currentBuilding.projectId, currentBuilding.siteId, { ...currentBuilding, props: { ...buildingProps } }, true);
};

const CorridorRefined = ({ currentBuilding, onChangeBuilding, sectionJson }: { currentBuilding: Building, onChangeBuilding: (projectId: number | string, siteId: number | string, building: Building, saveToDb: boolean) => void, sectionJson: SectionJSON }) => {

    const [buildingProps, setBuildingProps] = useState<PropsCorridor>(
        undefined
    );
    const [activePart, setActivePart] = useState<partTypeEnum>(
        partTypeEnum.bodyA
    );

    const getColumnTypes = (partType: partTypeEnum) => {
        let cols = [];
        if (partType === partTypeEnum.headLeft || partType === partTypeEnum.headRight) {
            cols = columnDefs.filter(s => s.columnSubtypes.includes(columnSubtype.head));
        } else if (partType === partTypeEnum.bodyA || partType === partTypeEnum.bodyB) {
            cols = columnDefs.filter(s => (s.columnSubtypes.includes(columnSubtype.body) || s.columnSubtypes.includes(columnSubtype.moosplaza)));
        }
        return cols.map(c => c.type);
    }


    const setUpDefaultColumnFromDefinition = (ct: headType | columnType, p: partTypeEnum) => {
        const coldef = columnDefs.find(c => c.type === ct)
        const columnService = new ColumnService();
        const segments = RefineService.getSegmentTypes(ct, columnDefs);
        if (segments && segments.length > 0) {
            let seg: Segment<segmentType, subtypeEnum, variantEnum>[] = []
            let amountOfUnits = [];
            segments.forEach(s => {
                const sg = RefineService.getSegmentDefinitionsForType(ct, s, columnDefs);
                const segDef = sg[0];
                let st = segDef.subtype;

                const floorDef = segDef.floorVariants[0];
                const floors = floorDef.floors;

                let variantDef = floorDef.variants[0];
                if (p === partTypeEnum.headRight && floorDef.variants.length === 2) {
                    variantDef = floorDef.variants[1];
                }
                seg.push({
                    type: s as segmentType,
                    subtype: st,
                    sectionTypes: variantDef.sections,
                    floorsInSegment: floors
                })
            })
            const col: CorridorColumn = {
                id: Math.random().toString(),
                type: ct,
                bays: coldef.bays,
                segments: seg,
                amountOfUnits
            }

            return col;
        }
    }

    const getDefaultColumnTypeForPart = (part) => {
        let type;
        if (part.type === partTypeEnum.bodyA || part.type === partTypeEnum.bodyB) {
            type = columnType.C_M;
        } else if (part.type === partTypeEnum.headLeft) {
            type = defaultHead;
        } else if (part.type === partTypeEnum.headRight) {
            type = defaultHead;
        }
        return type;
    }

    const updateBuildingColumn = (part, column) => {
        const bp = { ...buildingProps, partsRefined: [...buildingProps.partsRefined] };

        const partTypeToAdd = part.type;
        const partToAdd = bp.partsRefined[0].parts.find(p => p.type === partTypeToAdd);
        let columns = partToAdd.columns;

        columns = columns.map(col => col.id === column.id ? column : col);

        partToAdd.columns = [...columns.map(c => ({ ...c }))].sort((a, b) => a.order - b.order);

        bp.partsRefined[0].parts = ServiceManager.babylonService.corridorBabylonService.mapPartsTo3D(
            bp.partsRefined[0].parts,
            bp.moosPlazaAlignment,
            bp.moosPlazaPosition,
            true,
        );

        bp.info = ServiceManager.buildingHelperService.computePartInfo(bp.partsRefined[0].parts as any);
        const columnService = new ColumnService();
        columnService.computeAmountsForParts(bp.partsRefined[0].parts);
        bp.totalAmountOfAllUnits = columnService.getTotalAmountOfAllUnits(bp.partsRefined[0].parts);
        buildingChange(bp, currentBuilding, onChangeBuilding);
    }

    const updateBuildingColumns = (part, columns) => {
        const bp = { ...buildingProps, partsRefined: [...buildingProps.partsRefined] };

        const partToAdd = part.type;
        const partAdd = bp.partsRefined[0].parts.find(p => p.type === partToAdd);
        if (columns && columns.length > 0) {
            partAdd.columns = [...columns.map(c => ({ ...c }))].sort((a, b) => a.order - b.order);
        } else {
            partAdd.columns = [];
        }

        bp.partsRefined[0].parts = ServiceManager.babylonService.corridorBabylonService.mapPartsTo3D(
            bp.partsRefined[0].parts,
            bp.moosPlazaAlignment,
            bp.moosPlazaPosition,
            true,
        );

        bp.info = ServiceManager.buildingHelperService.computePartInfo(bp.partsRefined[0].parts as any);
        const columnService = new ColumnService();
        columnService.computeAmountsForParts(bp.partsRefined[0].parts);
        bp.totalAmountOfAllUnits = columnService.getTotalAmountOfAllUnits(bp.partsRefined[0].parts);
        buildingChange(bp, currentBuilding, onChangeBuilding);
    }

    useEffect(() => {
        if (currentBuilding && currentBuilding.props) {
            const buildingProps = currentBuilding.props as PropsCorridor;
            if (buildingProps && (!buildingProps.partsRefined || buildingProps.partsRefined.length === 0)) {
                const bp: any = { ...buildingProps, parts: [...buildingProps.parts] }
                // currently this is a single entity, but it might be expanded in the future
                bp.partsRefined = [{
                    id: 'first', parts: ServiceManager.buildingHelperService.cloneParts(bp.parts)
                }];
                setBuildingProps({ ...bp });
                buildingChange(bp, currentBuilding, onChangeBuilding);
            } else {
                setBuildingProps(buildingProps);
            }
        }
        //eslint-disable-next-line
    }, [currentBuilding]);

    const getPartName = (p: partTypeEnum) => {
        let name = '';
        switch (p) {
            case partTypeEnum.headLeft:
                name = 'Kop 1'
                break;
            case partTypeEnum.bodyA:
                name = 'Body A'
                break;
            case partTypeEnum.bodyB:
                name = 'Body B'
                break;
            case partTypeEnum.headRight:
                name = 'Kop 2'
                break;
        }
        return name;
    }

    const getVariantName = (variant: variantEnum): string => {
        if (variant === variantEnum.left) {
            return 'Links';
        } else if (variant === variantEnum.right) {
            return 'Rechts';
        } else {
            return 'Midden';
        }
    }

    const getSegmentName = (p: segmentType) => {
        let name = '';
        switch (p) {
            case segmentType.plinth:
                name = 'Plint';
                break;
            case segmentType.middle:
                name = 'Midden';
                break;
            case segmentType.crown:
                name = 'Kroon'
                break;
        }
        return name;
    }

    const getSegmentSubtypeName = (p: subtypeEnum) => {
        let name = '';
        switch (p) {
            case subtypeEnum.C:
                name = 'Corridor';
                break;
            case subtypeEnum.single:
                name = 'Geen'
                break;
        }
        return name;
    }

    return (
        <div className="group" data-testid="CorridorRefined">
            {buildingProps && buildingProps.partsRefined &&
                <>
                    <div>
                        <h2 className="greyed-out-text">Gebouw verfijnen</h2>
                        <CorridorPartSelector activePart={activePart} setActivePart={setActivePart} getPartName={getPartName} />
                        <Refine
                            part={buildingProps.partsRefined[0].parts.find(s => s.type === activePart)}
                            bt={currentBuilding.type}
                            buildingId={currentBuilding.id as string}
                            sectionJson={sectionJson}
                            segmentTypesMultipleFloors={[segmentType.middle]}
                            segmentTypesAllowCustom={[segmentType.plinth]}
                            columnDefs={columnDefs}
                            SegmentComponent={CorridorSegmentSelector}
                            floorHeight={ServiceManager.buildingHelperService.floorHeightOfBuilding(buildingType.doubleLoadedCorridor)}
                            getDefaultColumnTypeForPart={getDefaultColumnTypeForPart}
                            setUpDefaultColumnFromDefinition={setUpDefaultColumnFromDefinition}
                            updateBuildingColumn={updateBuildingColumn}
                            updateBuildingColumns={updateBuildingColumns}
                            getVariantName={getVariantName as any}
                            getSegmentName={getSegmentName as any}
                            getSegmentSubtypeName={getSegmentSubtypeName as any}
                        ></Refine>

                    </div>
                </>
            }
        </div>
    )
};

export default CorridorRefined;
